import { ResponseResult } from "../../Common/Models/ResponseResult";
import ResponseHandler from "../../App/ResponseHandler";
import { ApiRequest } from "../../Common";
import { Image } from "../Models/Image";
import { DeleteImage } from "../Models/DeleteImage";

class ImageUploadService {
  uploadImage(
    endpoint: string,
    imageToUpload: Image,
    success: (image: Image, response: Response, result: ResponseResult) => void,
    hasDuplicate: (hash: string) => Image | undefined,
    onDuplicate: () => void,
    onError: (response: Response, result: ResponseResult) => void,
    onFatalError: (response: Response) => void,
    cleanup?: () => void
  ) {
    const formData = new FormData();

    const image = { ...imageToUpload };

    if (imageToUpload.file) {
      formData.append(imageToUpload.file.name, imageToUpload.file);

      return ApiRequest.fromPath(endpoint)
        .withFormData(formData)
        .withAuthHeader()
        .post()
        .then((response: Response) => {
          ResponseHandler.handle(
            response,
            (result: ResponseResult<Image>) => {
              const { fullSizeObjectPath } = result.payload;
              const { thumbnailObjectPath } = result.payload;
              const hash = result.payload.fullSizeHash;
              const publicUrl = result.payload.fullSizeUrl;
              const { thumbnailUrl } = result.payload;

              const duplicate = hasDuplicate(hash);

              if (!duplicate) {
                image.fullSizeObjectPath = fullSizeObjectPath;
                image.thumbnailObjectPath = thumbnailObjectPath;
                image.fullSizeHash = hash;
                image.fullSizeUrl = publicUrl;
                image.thumbnailUrl = thumbnailUrl;

                success(image, response, result);
              } else {
                onDuplicate();
              }
            },
            result => {
              onError(response, result);
            },
            () => {
              onFatalError(response);
            }
          );
        })
        .finally(() => {
          if (cleanup) {
            cleanup();
          }
        });
    }

    throw new Error("File cannot be undefined.");
  }

  deleteImage(
    endpoint: string,
    deleteImage: DeleteImage,
    success: (response: Response, result: ResponseResult) => void,
    onError: (response: Response, result: ResponseResult) => void,
    onFatalError: (response: Response) => void
  ) {
    ApiRequest.fromPath(endpoint)
      .withAuthHeader()
      .withJson(deleteImage)
      .delete()
      .then((response: Response) => {
        ResponseHandler.handle(
          response,
          result => {
            success(response, result);
          },
          result => {
            onError(response, result);
          },
          () => {
            onFatalError(response);
          }
        );
      });
  }
}

export const imageUploadService = new ImageUploadService();
